/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import DeviceList from '../../device/device-list/deviceList.component'
import Layout from '../../layout-tank/layout'
import DeviceView, {
  DeviceViewContext,
} from '../../device/device-info-view/deviceView'
import styles from '../device-management/device-management.module.css'
import ProvisionConfirmDialog from '../../../device/device-provision/confirm-dialog'
import { DEVICE_STATUS_ENUM } from '../../../../services/device'
import DeviceConfigure from '../../device/device-info-view/deviceConfigure'

const TankDevicesProvision = () => {
  const [viewDevice, setViewDevice] = useState(false)
  const [viewDevice2, setViewDevice2] = useState(false)
  const [deviceData, setDeviceData] = useState(false)
  const [commandDevice, setCommandDevice] = useState(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [customerId, setCustomerId] = useState('')

  return (
    <Layout>
      <DeviceViewContext.Provider
        value={{
          viewDevice,
          setViewDevice,
          viewDevice2,
          setViewDevice2,
          commandDevice,
          setCommandDevice,
          deviceData,
          setDeviceData,
          showConfirmDialog,
          customerId,
          setCustomerId,
          setShowConfirmDialog,
        }}
      >
        <div className={styles.container}>
          {viewDevice ? (
            <DeviceView />
          ) : viewDevice2 ? (
            <DeviceConfigure />
          ) : (
            <DeviceList
              className={styles.list}
              status={DEVICE_STATUS_ENUM.CONFIGURED}
            />
          )}
        </div>
        <ProvisionConfirmDialog
          showConfirmDialog={showConfirmDialog}
          setShowConfirmDialog={setShowConfirmDialog}
          device={deviceData}
        />
      </DeviceViewContext.Provider>
    </Layout>
  )
}
export default TankDevicesProvision
